import React from 'react';
import { HiBellAlert } from "react-icons/hi2";
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import ClickOutside from './clickOtside';
import "./popupNotification.css";
import { FaArrowRight } from 'react-icons/fa';

interface PopoverNotificationProps {
  isOpen: boolean;
  onClose: () => void;
  notifications?: any;
  updateNotifications: () => void;
}

const PopoverNotification: React.FC<PopoverNotificationProps> = ({
  isOpen,
  onClose,
  notifications = [],
  updateNotifications,
}) => {
  const navigate = useNavigate();

  const handleNavigation = (event: React.MouseEvent, notification: any) => {
    event.preventDefault();
    // navigate(`/notification/${notification.id}`);
  };

  const goToAllNotifications = () => {
    onClose();
    updateNotifications();
    navigate('notification');
  };

  if (!isOpen) return null;

  return (
    <ClickOutside onClickOutside={onClose}>
      <div className="notification-popup">
        <header className="notification-popup__header">
          <h6 className="notification-popup__title">Notifications</h6>
          {notifications.length > 0 && (
            <span className="notification-popup__count">{notifications.length}</span>
          )}
        </header>

        <div className="notification-popup__list">
          {notifications.length > 0 ? (
            notifications.map((notification: any) => (
              <button
                type="button"
                key={notification?.id}
                className={`notification-popup__item ${notification?.seen ? 'notification-popup__item--seen' : ''}`}
                onClick={(e) => handleNavigation(e, notification)}
              >
                <span className="notification-popup__item-accent" aria-hidden />
                <span className="notification-popup__item-icon">
                  <HiBellAlert size={18} />
                </span>
                <span className="notification-popup__item-body">
                  <span className="notification-popup__item-type">{notification?.type}</span>
                  <span className="notification-popup__item-message">{notification?.message}</span>
                  <span className="notification-popup__item-time">
                    Created on {format(new Date(notification?.createdAt), 'MMM d, yyyy \'at\' h:mm a')}
                  </span>
                </span>
              </button>
            ))
          ) : (
            <div className="notification-popup__empty">
              <HiBellAlert size={32} className="notification-popup__empty-icon" />
              <p className="notification-popup__empty-text">No notifications</p>
              <p className="notification-popup__empty-hint">You're all caught up.</p>
            </div>
          )}
        </div>

        <footer className="notification-popup__footer">
          <button
            type="button"
            onClick={goToAllNotifications}
            className="notification-popup__btn-all"
          >
            View all notifications
            <FaArrowRight size={14} className="notification-popup__btn-all-icon" />
          </button>
        </footer>
      </div>
    </ClickOutside>
  );
};

export default PopoverNotification;
